<div class="no-print d-flex justify-content-end p-2 mb-2">
  <button type="button" class="btn btn-primary font-size-12" (click)="onDocsPrint('TransUnionCIBIL')">
    <i class="fa fa-print mr-1"></i> Print
  </button>
</div>

<div id="TransUnionCIBIL" class="cir-main-wrapper" *ngIf="consumer; else noDataTpl">

  <!-- Header Section -->
  <table class="site-header-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
    <tr>
      <td class="header-left-col">
        <table class="header-meta-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <td class="meta-date-cell">
              <span class="td-title">REPORT DATE & TIME</span> :
              <span class="td-desc">{{ formatDate(consumer.tuefHeader?.dateProcessed) }} ({{ formatTime(consumer.tuefHeader?.timeProcessed) }})</span>
            </td>
            <td class="meta-ctrl-cell">
              <span class="td-title">CONTROL NUMBER</span> :
              <span class="td-desc">{{ consumer.tuefHeader?.enquiryControlNumber || '-' }}</span>
            </td>
          </tr>
        </table>
      </td>
      <td class="header-right-col">
        <img class="header-tu-logo" alt="TransUnion CIBIL" src="assets/transunion.png" />
      </td>
    </tr>
  </table>

  <!-- Page Title -->
  <h1 class="page-title-text">Consumer CIR</h1>

  <!-- Member Details -->
  <table class="member-details-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
    <tr>
      <td style="width: 50%;">
        <span class="td-title">MEMBER ID</span><span class="colon">:</span>
        <span class="td-desc">{{ consumer.tuefHeader?.enquiryMemberUserId || '-' }}</span>
      </td>
      <td style="width: 50%; padding-left: 20px;">
        <span class="td-title">REFERENCE NUMBER</span><span class="colon">:</span>
        <span class="td-desc">{{ consumer.tuefHeader?.memberRefNo || 'STATUS' }}</span>
      </td>
    </tr>
  </table>

  <!-- Section: CONSUMER INFORMATION -->
  <div class="sec-heading">CONSUMER INFORMATION</div>
  <table class="consumer-info-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
    <tr>
      <td class="info-half-col first-col">
        <table class="inner-kv-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <td class="td-title">CONSUMER NAME</td>
            <td class="colon">:</td>
            <td class="td-desc font-weight-bold">{{ consumer.names?.[0]?.name || '-' }}</td>
          </tr>
          <tr>
            <td class="td-title">DOB</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ formatDate(consumer.names?.[0]?.birthDate) }}</td>
          </tr>
          <tr>
            <td class="td-title">TELEPHONE NO.</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ consumer.telephones?.[0]?.telephoneNumber || '-' }}</td>
          </tr>
          <tr>
            <td class="td-title">EMAIL ID</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ consumer.emails?.[0]?.emailID || '-' }}</td>
          </tr>
          <tr>
            <td class="td-title">Gender</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getGenderName(consumer.names?.[0]?.gender) }}</td>
          </tr>
          <tr>
            <td class="td-title">ADDRESS</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getFullConsumerAddress() }}</td>
          </tr>
        </table>
      </td>

      <td class="info-half-col">
        <table class="inner-kv-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
          <tr>
            <td class="td-title">PAN</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getPanNumber() }}</td>
          </tr>
          <tr>
            <td class="td-title">Driving licence no</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getDlNumber() }}</td>
          </tr>
          <tr>
            <td class="td-title">Voter ID</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getVoterId() }}</td>
          </tr>
          <tr>
            <td class="td-title">Passport no.</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getPassport() }}</td>
          </tr>
          <tr>
            <td class="td-title">Aadhaar Number (UID)</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getAadhaar() }}</td>
          </tr>
          <tr>
            <td class="td-title">CKYC</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getCkyc() }}</td>
          </tr>
          <tr>
            <td class="td-title">Other ID</td>
            <td class="colon">:</td>
            <td class="td-desc">{{ getOtherId() }}</td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <!-- Section: CIBIL Score -->
  <div class="sec-heading">CIBIL Transunion Score(s)</div>
  <table class="score-main-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
    <tr>
      <td class="score-title-cell">
        <p class="score-title-main">ENHANCED CREDITVISION<sup>®</sup><br />Score</p>
        <p class="score-subtitle-main">Ranges from:<br />300 (high risk) to 900 (low risk)</p>
      </td>
      <td class="score-gauge-cell">
        <svg style="overflow: visible; width: 170px; height: 130px; display: inline-block;" viewBox="0 0 200 135">
          <!-- Background grey arc (flat-cut ends at 300 and 900) -->
          <path d="M 25,100 A 75,75 0 0,1 175,100" fill="none" stroke="#D5D5D5" stroke-width="20" stroke-linecap="butt" />
          <!-- Colored blue score arc (starts at 300 and ends exactly at score) -->
          <path d="M 25,100 A 75,75 0 0,1 175,100" fill="none" stroke="#00A6CA" stroke-width="20" [attr.stroke-dasharray]="getScoreDashArray()" stroke-linecap="butt" />
          <!-- Exact Arrow: black triangle with white outline sitting at the end of the blue line pointing backwards along the arc -->
          <polygon [attr.points]="getArrowPoints()" fill="#000000" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round" />
          <!-- Center Score (Bold Black Text) -->
          <text x="100" y="98" text-anchor="middle" font-size="44" font-weight="900" fill="#000000" font-family="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif">{{ getScoreValue() || 'NTC' }}</text>
          <!-- 300 Label on Left -->
          <text x="25" y="125" text-anchor="middle" font-size="13" font-weight="700" fill="#8c8c8c">300</text>
          <!-- 900 Label on Right -->
          <text x="175" y="125" text-anchor="middle" font-size="13" font-weight="700" fill="#8c8c8c">900</text>
        </svg>
      </td>
      <td class="score-factors-cell">
        <p class="td-title" style="margin-bottom: 8px;">Scoring Factors</p>
        <ul class="score-factors-list">
          <li *ngFor="let factor of getScoreFactors()">
            {{ factor }}
          </li>
        </ul>
      </td>
    </tr>
  </table>

  <!-- Section: Account Summary -->
  <ng-container *ngIf="summary">
    <div class="sec-heading">CONSUMER ACCOUNT SUMMARY</div>
    <table class="summary-kpi-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
      <thead>
        <tr>
          <th>ACCOUNTS</th>
          <th>BALANCES</th>
          <th>ACCOUNT OPENED DATE</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <table class="inner-kv-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
              <tr>
                <td class="summary-title">Total</td>
                <td class="colon">:</td>
                <td class="summary-desc font-weight-bold">{{ summary.accountSummary?.totalAccounts ?? '-' }}</td>
              </tr>
              <tr>
                <td class="summary-title">Zero balance</td>
                <td class="colon">:</td>
                <td class="summary-desc font-weight-bold">{{ summary.accountSummary?.zeroBalanceAccounts ?? '-' }}</td>
              </tr>
              <tr>
                <td class="summary-title">Overdue</td>
                <td class="colon">:</td>
                <td class="summary-desc font-weight-bold">{{ summary.accountSummary?.overdueAccounts ?? '0' }}</td>
              </tr>
            </table>
          </td>
          <td>
            <table class="inner-kv-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
              <tr>
                <td class="summary-title">High Cr/Sanc. Amt</td>
                <td class="colon">:</td>
                <td class="summary-desc font-weight-bold">₹ {{ formatCurrency(summary.accountSummary?.highCreditAmount) }}</td>
              </tr>
              <tr>
                <td class="summary-title">Current</td>
                <td class="colon">:</td>
                <td class="summary-desc font-weight-bold">₹ {{ formatCurrency(summary.accountSummary?.currentBalance) }}</td>
              </tr>
              <tr>
                <td class="summary-title">Overdue</td>
                <td class="colon">:</td>
                <td class="summary-desc font-weight-bold">₹ {{ formatCurrency(summary.accountSummary?.overdueBalance || 0) }}</td>
              </tr>
            </table>
          </td>
          <td>
            <table class="inner-kv-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
              <tr>
                <td class="summary-title">Recent</td>
                <td class="colon">:</td>
                <td class="summary-desc">{{ formatDate(summary.accountSummary?.recentDateOpened) }}</td>
              </tr>
              <tr>
                <td class="summary-title">Oldest</td>
                <td class="colon">:</td>
                <td class="summary-desc">{{ formatDate(summary.accountSummary?.oldestDateOpened) }}</td>
              </tr>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- Section: Enquiry Summary -->
  <ng-container *ngIf="summary">
    <div class="sec-heading">ENQUIRY SUMMARY</div>
    <table class="enquiry-summary-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
      <thead>
        <tr>
          <th>TOTAL ENQUIRIES</th>
          <th>Most Recent</th>
          <th>Past 30 Days</th>
          <th>Past 12 Months</th>
          <th>Past 24 Months</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ summary.inquirySummary?.totalInquiry ?? '-' }}</td>
          <td>{{ formatDate(summary.inquirySummary?.recentInquiryDate) }}</td>
          <td>{{ summary.inquirySummary?.inquiryPast30Days ?? '0' }}</td>
          <td>{{ summary.inquirySummary?.inquiryPast12Months ?? '0' }}</td>
          <td>{{ summary.inquirySummary?.inquiryPast24Months ?? '0' }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- Section: Identification(s) -->
  <ng-container *ngIf="consumer.ids?.length">
    <div class="sec-heading">IDENTIFICATION(S)</div>
    <table class="cir-data-grid-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
      <thead>
        <tr>
          <th style="width: 28%;">TYPE</th>
          <th style="width: 36%;">ID NUMBER</th>
          <th style="width: 18%;">ISSUE DATE</th>
          <th style="width: 18%;">EXPIRATION DATE</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let idItem of consumer.ids; let i = index" [ngClass]="i % 2 === 0 ? 'alt-row' : ''">
          <td>{{ getIdTypeName(idItem.idType) }}</td>
          <td><strong>{{ idItem.idNumber }}</strong></td>
          <td>{{ formatDate(idItem.issueDate) }}</td>
          <td>{{ formatDate(idItem.expirationDate) }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- Section: Telephone(s) -->
  <ng-container *ngIf="consumer.telephones?.length">
    <div class="sec-heading">TELEPHONE(S)</div>
    <table class="cir-data-grid-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
      <thead>
        <tr>
          <th style="width: 30%;">TYPE</th>
          <th style="width: 45%;">Telephone NUMBER</th>
          <th style="width: 25%;">TELEPHONE EXTENSION</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tel of consumer.telephones; let i = index" [ngClass]="i % 2 === 0 ? 'alt-row' : ''">
          <td>{{ getTelephoneTypeName(tel.telephoneType) }}</td>
          <td><strong>{{ tel.telephoneNumber }}</strong></td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- Section: Email Contact(s) -->
  <ng-container *ngIf="consumer.emails?.length">
    <div class="sec-heading">EMAIL CONTACT(S)</div>
    <table class="cir-data-grid-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
      <thead>
        <tr>
          <th style="width: 100%;">EMAIL ADDRESS</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let em of consumer.emails; let i = index" [ngClass]="i % 2 === 0 ? 'alt-row' : ''">
          <td>{{ em.emailID }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- Section: Reported Addresses -->
  <ng-container *ngIf="consumer.addresses?.length">
    <div class="sec-heading">CONSUMER’S REPORTED ADDRESS(ES)</div>
    <table class="cir-data-grid-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
      <thead>
        <tr>
          <th style="width: 46%;">Address</th>
          <th style="width: 18%;">Category</th>
          <th style="width: 18%;">RESIDENCE CODE</th>
          <th style="width: 18%;">Date Reported</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let addr of consumer.addresses; let i = index" [ngClass]="i % 2 === 0 ? 'alt-row' : ''">
          <td style="word-break: break-word; white-space: normal; overflow-wrap: break-word;">
            <div style="font-size: 12px; line-height: 16px; color: #1e293b;">
              {{ addr.line1 }}<span *ngIf="addr.line2">, {{ addr.line2 }}</span><span *ngIf="addr.line3">, {{ addr.line3 }}</span><span *ngIf="addr.line4">, {{ addr.line4 }}</span><span *ngIf="addr.line5">, {{ addr.line5 }}</span>
            </div>
            <div style="color: #64748b; font-size: 11px; margin-top: 3px;">
              PIN - {{ addr.pinCode }} (State: {{ addr.stateCode }})
            </div>
          </td>
          <td>{{ getAddressCategoryName(addr.addressCategory) }}</td>
          <td>{{ addr.residenceCode === '02' ? 'Rented' : 'Owned' }}</td>
          <td>{{ formatDate(addr.dateReported) }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- Section: Employment Information -->
  <ng-container *ngIf="consumer.employment?.length">
    <div class="sec-heading">Employment Information</div>
    <table class="cir-data-grid-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
      <thead>
        <tr>
          <th style="width: 30%;">ACCOUNT TYPE (Date Reported)</th>
          <th style="width: 20%;">OCCUPATION CODE</th>
          <th style="width: 15%;">Income</th>
          <th style="width: 17%;">NET/Gross Income Indicator</th>
          <th style="width: 18%;">Monthly/Annual Income indicator</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let emp of consumer.employment">
          <td>
            {{ getAccountTypeName(emp.accountType) }} ({{ formatDate(emp.dateReported) }})
          </td>
          <td>{{ emp.occupationCode === '03' ? 'Self Employed / Others' : emp.occupationCode || '-' }}</td>
          <td>₹ {{ formatCurrency(emp.income) }}</td>
          <td>{{ emp.incomeType === 'G' ? 'Gross' : 'Net' }}</td>
          <td>{{ emp.incomeFrequency === 'A' ? 'Annual' : 'Monthly' }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- Section: Consumer Account Details -->
  <ng-container *ngIf="processedAccounts?.length">
    <h2 class="page-title-text" style="font-size: 22px; margin-top: 25px; margin-bottom: 20px;">CONSUMER ACCOUNT DETAILS</h2>

    <!-- Accounts Loop -->
    <ng-container *ngFor="let acc of processedAccounts; let idx = index">
      <div class="sec-heading" style="font-size: 16px; margin-bottom: 8px;">{{ idx + 1 }}. Account</div>

      <!-- Account Top Head -->
      <table class="ac-head-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
        <tr>
          <td class="ac-title-cell">ACCOUNT INFORMATION</td>
          <td class="ac-dates-cell">
            <span class="td-title">DATe Opened</span>: <span class="td-desc">{{ formatDate(acc.dateOpened) }}</span>
            <span class="pipe-sep">|</span>
            <span class="td-title">DATe CLOSED</span>: <span class="td-desc">{{ formatDate(acc.dateClosed) }}</span>
            <span class="pipe-sep">|</span>
            <span class="td-title">DATE REPORTED & CERTIFIED</span>: <span class="td-desc">{{ formatDate(acc.dateReported) }}</span>
          </td>
          <td class="ac-status-cell" [ngClass]="acc.dateClosed ? 'status-inactive' : 'status-active'">
            {{ acc.dateClosed ? 'inactive' : 'active' }}
          </td>
        </tr>
      </table>

      <!-- Account 3-Panel Body -->
      <table class="ac-body-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
        <tr>
          <!-- Panel 1: Account -->
          <td class="ac-panel-left">
            <div class="panel-header-title">ACCOUNT</div>
            <table class="inner-kv-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
              <tr>
                <td class="td-title">TYPE</td><td class="colon">:</td>
                <td class="td-desc font-weight-bold">{{ getAccountTypeName(acc.accountType) }}</td>
              </tr>
              <tr>
                <td class="td-title">MEMBER NAME</td><td class="colon">:</td>
                <td class="td-desc">{{ acc.memberShortName || 'NOT DISCLOSED' }}</td>
              </tr>
              <tr>
                <td class="td-title">Account Number</td><td class="colon">:</td>
                <td class="td-desc">{{ acc.index || 'Not Disclosed' }}</td>
              </tr>
              <tr>
                <td class="td-title">OWNERSHIP</td><td class="colon">:</td>
                <td class="td-desc">{{ getOwnershipName(acc.ownershipIndicator) }}</td>
              </tr>
            </table>
          </td>

          <!-- Panel 2: Amounts -->
          <td class="ac-panel-middle">
            <div class="panel-header-title">AMOUNTS</div>
            <table class="ac-amounts-layout-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
              <tr>
                <td style="width: 50%; vertical-align: top; padding-right: 6px;">
                  <table class="ac-kv-sub-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
                    <tr>
                      <td class="td-title">SANCTIONED AMOUNT</td><td class="colon">:</td>
                      <td class="td-desc font-weight-bold">₹ {{ formatCurrency(acc.highCreditAmount) }}</td>
                    </tr>
                    <tr>
                      <td class="td-title">CURRENT BALANCE</td><td class="colon">:</td>
                      <td class="td-desc font-weight-bold">₹ {{ formatCurrency(acc.currentBalance) }}</td>
                    </tr>
                    <tr *ngIf="acc.actualPaymentAmount">
                      <td class="td-title">ACTUAL PAYMENT</td><td class="colon">:</td>
                      <td class="td-desc">₹ {{ formatCurrency(acc.actualPaymentAmount) }}</td>
                    </tr>
                    <tr *ngIf="acc.collateralValue">
                      <td class="td-title">COLLATERAL VALUE</td><td class="colon">:</td>
                      <td class="td-desc">₹ {{ formatCurrency(acc.collateralValue) }}</td>
                    </tr>
                    <tr *ngIf="acc.creditLimit">
                      <td class="td-title">CREDIT LIMIT</td><td class="colon">:</td>
                      <td class="td-desc">₹ {{ formatCurrency(acc.creditLimit) }}</td>
                    </tr>
                  </table>
                </td>
                <td style="width: 50%; vertical-align: top; padding-left: 6px;">
                  <table class="ac-kv-sub-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
                    <tr *ngIf="acc.paymentFrequency">
                      <td class="td-title">PAYMENT FREQUENCY</td><td class="colon">:</td>
                      <td class="td-desc">{{ getPaymentFrequencyName(acc.paymentFrequency) }}</td>
                    </tr>
                    <tr *ngIf="acc.paymentTenure">
                      <td class="td-title">REPAYMENT TENURE</td><td class="colon">:</td>
                      <td class="td-desc">{{ acc.paymentTenure }}</td>
                    </tr>
                    <tr *ngIf="acc.interestRate">
                      <td class="td-title">INTEREST RATE</td><td class="colon">:</td>
                      <td class="td-desc">{{ acc.interestRate }}</td>
                    </tr>
                    <tr *ngIf="acc.emiAmount">
                      <td class="td-title">EMI</td><td class="colon">:</td>
                      <td class="td-desc">₹ {{ formatCurrency(acc.emiAmount) }}</td>
                    </tr>
                    <tr *ngIf="acc.collateralType">
                      <td class="td-title">COLLATERAL TYPE</td><td class="colon">:</td>
                      <td class="td-desc">{{ acc.collateralType }}</td>
                    </tr>
                    <tr *ngIf="acc.cashLimit">
                      <td class="td-title">CASH LIMIT</td><td class="colon">:</td>
                      <td class="td-desc">₹ {{ formatCurrency(acc.cashLimit) }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>

          <!-- Panel 3: Status -->
          <td class="ac-panel-right">
            <div class="panel-header-title">STATUS</div>
            <div class="td-desc" style="padding: 6px 0;">NA</div>
          </td>
        </tr>
      </table>

      <!-- Account DPD Sub Head -->
      <table class="ac-dpd-head-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
        <tr>
          <td class="ac-title-cell" style="width: 35%;">DAYS PAST DUE/ASSET CLASSIFICATION</td>
          <td class="ac-dates-cell" style="width: 65%;">
            <span class="td-title">START DATE</span>: <span class="td-desc">{{ formatDate(acc.paymentStartDate || acc.dateReported) }}</span>
            <span class="pipe-sep">|</span>
            <span class="td-title">END DATE</span>: <span class="td-desc">{{ formatDate(acc.paymentEndDate || acc.dateOpened) }}</span>
            <span class="pipe-sep">|</span>
            <span class="td-title">LAST PAYMENT</span>: <span class="td-desc">{{ formatDate(acc.lastPaymentDate) }}</span>
          </td>
        </tr>
      </table>

      <!-- Yearly Payment Grid -->
      <table class="yearly-dpd-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" style="margin-bottom: 25px;">
        <thead>
          <tr>
            <th>YEAR</th><th>JAN</th><th>FEB</th><th>MAR</th><th>APR</th><th>MAY</th><th>JUN</th><th>JUL</th><th>AUG</th><th>SEP</th><th>OCT</th><th>NOV</th><th>DEC</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let yr of acc.yearlyHistory; let yIdx = index" [ngClass]="yIdx % 2 === 0 ? 'alt-row' : ''">
            <td class="year-hdr">{{ yr.year }}</td>
            <td>{{ yr.months.JAN }}</td>
            <td>{{ yr.months.FEB }}</td>
            <td>{{ yr.months.MAR }}</td>
            <td>{{ yr.months.APR }}</td>
            <td>{{ yr.months.MAY }}</td>
            <td>{{ yr.months.JUN }}</td>
            <td>{{ yr.months.JUL }}</td>
            <td>{{ yr.months.AUG }}</td>
            <td>{{ yr.months.SEP }}</td>
            <td>{{ yr.months.OCT }}</td>
            <td>{{ yr.months.NOV }}</td>
            <td>{{ yr.months.DEC }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </ng-container>

  <!-- Section: Enquiries -->
  <ng-container *ngIf="processedEnquiries?.length">
    <div class="sec-heading">ENQUIRIES</div>
    <table class="cir-data-grid-tbl" role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0">
      <thead>
        <tr>
          <th style="width: 20%;">Date of Enquiry</th>
          <th style="width: 35%;">Member Short Name</th>
          <th style="width: 25%;">Enquiry Purpose</th>
          <th style="width: 20%; text-align: right;">Enquiry Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let enq of processedEnquiries; let i = index" [ngClass]="i % 2 === 0 ? 'alt-row' : ''">
          <td>{{ formatDate(enq.enquiryDate) }}</td>
          <td>{{ enq.memberShortName || 'NOT DISCLOSED' }}</td>
          <td>{{ getEnquiryPurposeName(enq.enquiryPurpose) }}</td>
          <td style="text-align: right; font-weight: bold;">₹ {{ formatCurrency(enq.enquiryAmount) }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <!-- Footer -->
  <footer class="cir-footer-div">
    <p class="footer-text-dark">TransUnion CIBIL Limited (Formerly: Credit Information Bureau (India) Limited)</p>
    <p class="footer-text-light">This Consumer Credit Information Report is generated for official evaluation purposes only.</p>
  </footer>

</div>

<ng-template #noDataTpl>
  <div class="p-4 text-center">
    <i class="fa fa-file-text-o fa-2x text-muted mb-2"></i>
    <p class="text-muted fs-12 mb-0">No CIBIL Consumer CIR Data Available</p>
  </div>
</ng-template>